(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bio-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bio-carousel')) {
    class BioCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.bio-slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 6000;
        this.style.setProperty('--bio-speed', this.speed + 'ms');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduced;
        if (this.slides.length < 2) return;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dot, 10), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.stop(); }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
          this.start();
        });
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        this.start();
      }
      disconnectedCallback() {
        this.stop();
      }
      go(i, user) {
        const n = this.slides.length;
        const next = (i + n) % n;
        if (next === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.dots[this.index]?.classList.remove('is-active');
        this.index = next;
        this.slides[next].classList.add('is-active');
        const dot = this.dots[next];
        if (dot) {
          dot.classList.remove('is-active');
          void dot.offsetWidth;
          dot.classList.add('is-active');
        }
        if (user) this.restart();
      }
      start() {
        if (!this.autoplay || this.timer) return;
        this.classList.add('is-playing');
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }
      stop() {
        clearInterval(this.timer);
        this.timer = null;
        this.classList.remove('is-playing');
      }
      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('bio-carousel', BioCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bio-categories"] && !Shopify.designMode) return;
  try {
    
 (function () {
  if (window.__bioReveal) return;
  window.__bioReveal = true;
  document.documentElement.classList.add('bio-js');
  const init = (root) => {
   const els = (root || document).querySelectorAll('[data-bio-reveal]:not(.is-visible)');
   if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
   }
   const io = new IntersectionObserver(
    (entries) => {
     entries.forEach((entry) => {
      if (entry.isIntersecting) {
       entry.target.classList.add('is-visible');
       io.unobserve(entry.target);
      }
     });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
   );
   els.forEach((el) => io.observe(el));
  };
  if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', () => init());
  } else {
   init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
